import { render, staticRenderFns } from "./ResetPasswordModal.vue?vue&type=template&id=38e6cda6&"
import script from "./ResetPasswordModal.vue?vue&type=script&lang=js&"
export * from "./ResetPasswordModal.vue?vue&type=script&lang=js&"
import style0 from "./ResetPasswordModal.vue?vue&type=style&index=0&id=38e6cda6&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* custom blocks */
import block0 from "@/locale/modals/generic.json?vue&type=custom&index=0&blockType=i18n&issuerPath=%2FVolumes%2FSi%2Fdev%2Fvallas.do%2Ffrontend%2Fsrc%2Fcomponents%2FModales%2FResetPasswordModal.vue"
if (typeof block0 === 'function') block0(component)
import block1 from "@/locale/modals/forgotPassword.json?vue&type=custom&index=1&blockType=i18n&issuerPath=%2FVolumes%2FSi%2Fdev%2Fvallas.do%2Ffrontend%2Fsrc%2Fcomponents%2FModales%2FResetPasswordModal.vue"
if (typeof block1 === 'function') block1(component)
import block2 from "@/locale/modals/alertas.json?vue&type=custom&index=2&blockType=i18n&issuerPath=%2FVolumes%2FSi%2Fdev%2Fvallas.do%2Ffrontend%2Fsrc%2Fcomponents%2FModales%2FResetPasswordModal.vue"
if (typeof block2 === 'function') block2(component)

export default component.exports